import { useState } from 'react';
import useAuthContext from './useAuthContext';
import { request } from '../utils/axios-utils';
import { useNavigate } from 'react-router-dom';

const useLogin = () => {
    const { dispatcher } = useAuthContext();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const login = (email, username, credential) => {
        setIsLoading(true);
        request({
            url: '/auth/login',
            method: 'POST',
            data: { email, name: username, token: credential },
        })
            .then(response => {
                dispatcher({
                    type: 'LOGIN',
                    payload: response.data,
                });
                let mail = btoa(email);
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('user', JSON.stringify(response.data));
                localStorage.setItem('email', mail);
                setIsLoading(false);
                navigate('/dashboard');
            })
            .catch(error => {
                setError(error);
                setIsLoading(false);
            });
    };

    return { login, isLoading, error };
};

export default useLogin;
